<script lang="ts">
	import MultiplePageLayout from "@hitit/hub/src/layouts/MultiplePageLayout.svelte";
	import PointHistory from "./PointHistory.svelte";
	import ManageClient from "./ManageClient.svelte";
	import { navigate, Router, Route } from "svelte-routing";
	import { t } from "../../stores";

	export let storeId = "";

	$: headerInfos = [
		{
			title: $t("global.point.pointHistory"),
			clickEvent: () => navigate("/earning/history"),
			route: "/earning/history/*",
		},
		{
			title: $t("global.point.Members"),
			clickEvent: () => navigate("/earning/client"),
			route: "/earning/client/*",
		},
	];

</script>

<MultiplePageLayout headerInfos={headerInfos}>
	<Router>
		<Route path="/history">
			<PointHistory storeId={storeId} />
		</Route>
		<Route path="/client">
			<ManageClient storeId={storeId} />
		</Route>
	</Router>
</MultiplePageLayout>

<style lang="scss">
</style>
